import React from "react";
import Expandable from "../filters/Expandable";
import { Link } from "react-router-dom";

const SubjectSideBar = ({ data, title, type, current }) => {
  return (
    <div>
      {(type
        ? data.series_list && !data.series_list.series_list
        : data.subject_list && !data.subject_list.subject_list) && (
        <div className="col-xs-12 refine hidden-lg hidden-md">
          <div className="col-xs-5 col-sm-6 pull-left">
            <span className="lists_heading">{title}</span>
          </div>
          <div className="col-xs-5 col-sm-2 pull-right">
            <div className="dropdown" style={{ float: "right" }}>
              <a
                href="/"
                data-toggle="dropdown"
                className="dropdown-toggle pull-left blog_refine"
                style={{
                  border: "1px solid #ccc",
                  padding: "5px 0px 5px 10px",
                }}
              >
                REFINE BY
                <span className="glyphicon glyphicon-menu-down menu_arrow" />
              </a>
              <ul className="dropdown-menu blog_refine refine_subjects">
                {type
                  ? data.series_list.map((series) => (
                      <li key={series.series_id}>
                        <Link
                        to={`/serieslanding?subject_slug=${series.subject_slug}&series_slug=${series.series_slug}`}
                        >
                          {" "}
                          {series.series_name}
                        </Link>
                      </li>
                    ))
                  : data.subject_list.map((category) => (
                      <li key={category.subject_id}>
                        <Link
                          to={`/subjectlanding?subject_slug=${category.subject_slug}`}
                        >
                          {" "}
                          {category.subject_name}
                        </Link>
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      {(!data.subject_list.subject_list || !data.series_list.series_list) && (
        <div
          className="hidden-xs hidden-sm col-sm-3 col-md-3 col-lg-3"
          style={{ border: "solid red 0px" }}
        >
          <div className="refine_heading pull-left">REFINE BY</div>
          {data.subject_list && !type && !data.subject_list.subject_list && (
            <div className="sociology_lists pull-left">
              <span className="lists_heading">{title} Topics</span>
              <ul className="refine_lists_topics refine_subject subject_filter">
                {data.subject_list.map((category) => (
                  <li className="display_block" key={category.subject_id}>
                    {current === category.subject_name ? (
                      <Link
                        className="refine_subject_selected"
                        to={`/subjectlanding?subject_slug=${category.subject_slug}`}
                      >
                        {category.subject_name}
                      </Link>
                    ) : (
                      <Link
                        to={`/subjectlanding?subject_slug=${category.subject_slug}`}
                      >
                        {category.subject_name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!type
            ? !data.series_list.series_list && (
                <Expandable data={data.series_list} type={"Series"} />
              )
            : !data.subject_list.subject_list && (
                <Expandable data={data.subject_list} type={title + " Topics"} />
              )}
          {type && (
            <div className="sociology_lists pull-left">
              <span className="lists_heading">Series</span>
              <ul className="refine_lists_topics refine_subject subject_filter">
                {data.series_list.map((category) => (
                  <li className="display_block" key={category.series_id}>
                    {category.series_name === type ? (
                      <Link
                        className="refine_subject_selected"
                        to={`/serieslanding?subject_slug=${category.subject_slug}&series_slug=${category.series_slug}`}
                      >
                        {category.series_name}
                      </Link>
                    ) : (
                      <Link
                        to={`/serieslanding?subject_slug=${category.subject_slug}&series_slug=${category.series_slug}`}
                      >
                        {category.series_name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default SubjectSideBar;
